import Link from 'next/link'
import styled from 'styled-components'

import { theme } from '@/styles/theme'
import { IR_TOP_ROUTE } from '@/utils/routes'

import { Button } from '@/components/elements/Button'

const MidTermManagementPlanLink = IR_TOP_ROUTE.subdirectories[6].path

export const MidTermManagementPlanCard = () => {
  return (
    <Card>
      <Title>
        <h2>中期経営計画</h2>
      </Title>
      <Explanation>2027年6月期-2029年6月期</Explanation>
      <Link href={MidTermManagementPlanLink} passHref>
        <a>
          <LinkButton btnStyle="transparent">中期経営計画</LinkButton>
        </a>
      </Link>
    </Card>
  )
}

const Card = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 22px 20px;
  gap: 10px;
  background: ${theme.colors.backgroundGrey};
  border-radius: 8px;
`

const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 12px;
  width: 100%;
  border-bottom: 1px solid ${theme.colors.grey};
  color: ${theme.colors.textTitle};
  text-align: center;
  height: 57px;

  @media screen and (max-width: 1047px) {
    height: 55px;
  }

  > h2 {
    font-weight: 700;
    font-size: 22px;
    line-height: 1.2;

    @media screen and (max-width: 1047px) {
      font-size: 20px;
    }
  }

  > span {
    font-weight: 500;
    font-size: 12px;
    line-height: 1.6;
  }
`

const Explanation = styled.div`
  height: 28px;
  padding-top: 4px;
  padding-bottom: 10px;
  align-items: center;
  font-weight: 500;
  font-size: 12px;
  line-height: 1.2;
  color: ${theme.colors.textSecond};
`

const LinkButton = styled(Button)`
  width: 200px;
  height: 42px;
  padding: 11px 26px 13px;
  font-weight: 500;
  font-size: 16px;
  line-height: 1;
  background-color: #ffffff;

  @media screen and (max-width: 1047px) {
    width: 295px;
    height: 42px;
  }
`